import React, { useEffect, useRef } from 'react';

const AppDialog = ({
  visible,
  onHide,
  header,
  children,
  footer,
  className = '',
  boxClassName = '',
  closeOnBackdrop = true,
  position = 'modal-middle',
  ...rest
}) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (visible && !dialog.open) {
      dialog.showModal();
    } else if (!visible && dialog.open) {
      dialog.close();
    }
  }, [visible]);

  const handleClose = () => {
    if (onHide) onHide();
  };

  return (
    <dialog
      ref={dialogRef}
      className={`modal ${position} ${className}`}
      onClose={handleClose}
      {...rest}
    >
      <div className={`modal-box bg-base-100 ${boxClassName}`}>
        {/* Close Button at top right */}
        {onHide && (
          <button 
            type="button"
            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            onClick={handleClose}
          >
            ✕
          </button>
        )}
        
        {/* Header */}
        {header && (
          <h3 className="font-bold text-lg mb-4 text-base-content border-b border-base-200 pb-2">
            {header}
          </h3>
        )}
        
        {/* Body */}
        <div className="py-2">
          {children}
        </div>
        
        {/* Footer */}
        {footer && (
          <div className="modal-action mt-6 border-t border-base-200 pt-4">
            {footer}
          </div>
        )}
      </div>

      {/* Backdrop (clicking it closes the modal) */}
      <form method="dialog" className="modal-backdrop">
        <button 
          type="button" 
          onClick={closeOnBackdrop ? handleClose : undefined}
          disabled={!closeOnBackdrop}
        >
          close
        </button>
      </form>
    </dialog>
  );
};

export default AppDialog;
